import React from 'react';
import PropTypes from 'prop-types';

import {
  Clock,
  DollarSign,
  ClipboardList,
  Users,
  Contact,
  Settings,
  FilePlus,
  Inbox,
  GraduationCap,
  Truck,
  MapPin,
  BookOpen,
  MessageCircle,
  FileText
} from 'lucide-react';
import SideNavItem from './SideNavItem';

const userMenuItems = [
  { text: 'My Time', icon: <Clock className="tw-h-5 tw-w-5" />, path: '/mytime' },
  { text: 'My Expenses', icon: <DollarSign className="tw-h-5 tw-w-5" />, path: '/myexpenses' },
  { text: 'My Asset', icon: <Truck className="tw-h-5 tw-w-5" />, path: '/myasset' },
  { text: 'My Asset Maps', icon: <MapPin className="tw-h-5 tw-w-5" />, path: '/myassetmaps' },
  { text: 'My Task', icon: <ClipboardList className="tw-h-5 tw-w-5" />, path: '/myTask' }
];

const adminMenuItems = [
  { text: 'Message', icon: <MessageCircle className="tw-h-5 tw-w-5" />, path: '/message', expandable: true },
  {
    text: 'Timesheets and Logs',
    icon: <ClipboardList className="tw-h-5 tw-w-5" />,
    path: '/timesheets',
    expandable: true
  },
  { text: 'Invoices', icon: <FileText className="tw-h-5 tw-w-5" />, path: '/invoices', expandable: true },
  { text: 'Users', icon: <Users className="tw-h-5 tw-w-5" />, path: '/users' },
  { text: 'Total Task', icon: <ClipboardList className="tw-h-5 tw-w-5" />, path: '/totalTask' },
  { text: 'Qualification', icon: <BookOpen className="tw-h-5 tw-w-5" />, path: '/qualifications', expandable: true },
  { text: 'Expenses', icon: <DollarSign className="tw-h-5 tw-w-5" />, path: '/expenses' },
  { text: 'Customers', icon: <Contact className="tw-h-5 tw-w-5" />, path: '/customers' },
  { text: 'Suppliers', icon: <Users className="tw-h-5 tw-w-5" />, path: '/suppliers' },
  { text: 'Item', icon: <Inbox className="tw-h-5 tw-w-5" />, path: '/item' },
  { text: 'Class', icon: <GraduationCap className="tw-h-5 tw-w-5" />, path: '/class' },
  { text: 'QboEmployee', icon: <FilePlus className="tw-h-5 tw-w-5" />, path: '/qboEmployee' },
  { text: 'Setup', icon: <Settings className="tw-h-5 tw-w-5" />, path: '/setup' },
  {
    text: 'Asset',
    icon: <Truck className="tw-h-5 tw-w-5" />,
    path: '/asset',
    expandable: true
  }
];

const SideNavList = ({
  isCollapsed,
  mobileOpen,
  handleDrawerToggle,
  role,
  selectedItem,
  handleListItemClick,
  handleLargeDevice,
  expandNestedItem,
  myTaskNotificationCount,
  qualificationNotificationCount
}) => {
  const commonProps = {
    selectedItem,
    handleListItemClick,
    handleLargeDevice,
    expandNestedItem,
    isCollapsed
  };
  return (
    <div className="tw-flex-1 tw-w-full">
      {role && role === 'User' && (
        <ul className="tw-space-y-1">
          {userMenuItems.map(({ text, icon, path }) => (
            <SideNavItem
              key={text}
              selectedItem={selectedItem}
              mobileOpen={mobileOpen}
              handleListItemClick={handleListItemClick}
              handleLargeDevice={handleLargeDevice}
              primaryText={text}
              icon={icon}
              to={path}
              taskNotificationCount={text === 'My Task' ? myTaskNotificationCount : 0}
            />
          ))}
        </ul>
      )}

      {role && role === 'Admin' && (
        <ul className="tw-space-y-1">
          {adminMenuItems.map(({ text, icon, path, expandable }) => (
            <SideNavItem
              key={text}
              selectedItem={selectedItem}
              mobileOpen={mobileOpen}
              handleListItemClick={handleListItemClick}
              handleLargeDevice={handleLargeDevice}
              primaryText={text}
              icon={icon}
              expandNestedItem={expandable ? expandNestedItem : undefined}
              taskNotificationCount={text === 'My Task' ? myTaskNotificationCount : 0}
              qualsNotificationCount={text === 'Qualification' ? qualificationNotificationCount : 0}
              to={path}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default SideNavList;

SideNavList.propTypes = {
  mobileOpen: PropTypes.bool,
  handleListItemClick: PropTypes.func,
  role: PropTypes.string,
  selectedItem: PropTypes.any,
  handleLargeDevice: PropTypes.func,
  expandNestedItem: PropTypes.any,
  myTaskNotificationCount: PropTypes.number,
  qualificationNotificationCount: PropTypes.number
};
